import { render, staticRenderFns } from "./SaldosContables.vue?vue&type=template&id=44866bc0"
import script from "./SaldosContables.vue?vue&type=script&lang=js"
export * from "./SaldosContables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports